/**
 * NavigationTabMenu - Reusable TabMenu for page navigation
 *
 * Follows PrimeReact Diamond template pattern exactly
 */

import React, { useState, useEffect, useCallback } from 'react';
import { TabMenu } from 'primereact/tabmenu';
import { useNavigate, useLocation } from 'react-router-dom';

// Sticky styles for TabMenu
const containerStyles = `
    .navigation-tabmenu-container {
        position: sticky;
        top: 4rem;
        z-index: 100;
        background-color: var(--surface-card);
        margin-top: -2rem;
        margin-bottom: 1rem;
    }

    @media screen and (max-width: 991px) {
        .navigation-tabmenu-container {
            top: 7.125rem;
        }
    }

    /* Mobile: horizontal scroll for tabs */
    @media screen and (max-width: 576px) {
        .navigation-tabmenu-container .p-tabmenu .p-tabmenu-nav {
            flex-wrap: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
        }

        .navigation-tabmenu-container .p-tabmenu .p-tabmenu-nav .p-tabmenuitem {
            flex-shrink: 0;
        }

        .navigation-tabmenu-container .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {
            padding: 0.85rem 0.75rem;
            font-size: 0.95rem;
            white-space: nowrap;
        }

        .navigation-tabmenu-container .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link .p-menuitem-icon {
            font-size: 1.1rem;
            margin-right: 0.4rem;
        }
    }
`;

const NavigationTabMenu = ({ tabs }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState(0);

    const checkActiveIndex = useCallback(() => {
        const index = tabs.findIndex(tab => location.pathname === tab.route);
        if (index !== -1) setActiveIndex(index);
    }, [location.pathname, tabs]);

    useEffect(() => {
        checkActiveIndex();
    }, [checkActiveIndex]);

    const model = tabs.map(tab => ({
        label: tab.label,
        icon: tab.icon,
        command: () => navigate(tab.route)
    }));

    return (
        <>
            <style>{containerStyles}</style>
            <div className="navigation-tabmenu-container">
                <TabMenu
                    model={model}
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                />
            </div>
        </>
    );
};

export default NavigationTabMenu;
